export default function convertColumnTypeToDisplayName(type: string) {
  if (type === 'STRING') return 'TEXT';
  return type;
}
